// extracted by mini-css-extract-plugin
export default {"root":"TopologySVGIcon_root__O+0zc","card":"TopologySVGIcon_card__LcUHz"};